module.exports = __webpack_public_path__ + "img/monitoring-tow-yellow.390f9e0f.svg";